const SPANISH_MOBILE_DIGITS = /^34[67]\d{8}$/;
const NATIONAL_MOBILE_DIGITS = /^[67]\d{8}$/;

/**
 * @param {string | null | undefined} phone
 * @returns {string | null} E.164 (+34…) or null when the value is not a Spanish mobile.
 */
export function normalizeSpanishBizumMobile(phone) {
  const digits = String(phone || "").replace(/\D/g, "");
  const withCountry = NATIONAL_MOBILE_DIGITS.test(digits) ? `34${digits}` : digits;
  if (!SPANISH_MOBILE_DIGITS.test(withCountry)) {
    return null;
  }
  return `+${withCountry}`;
}

/**
 * @typedef {{ valid: true; normalized: string; errorKey: "" } | { valid: false; normalized: null; errorKey: string }} BizumPhoneValidation
 */

/**
 * Bizum only accepts Spanish mobiles (prefix +34, national number starting with 6 or 7).
 * @param {string | null | undefined} phone
 * @returns {BizumPhoneValidation}
 */
export function validateSpanishBizumMobile(phone) {
  const trimmed = String(phone || "").trim();
  if (!trimmed) {
    return { valid: false, normalized: null, errorKey: "checkout.bizumPhoneRequired" };
  }

  const normalized = normalizeSpanishBizumMobile(trimmed);
  if (!normalized) {
    return { valid: false, normalized: null, errorKey: "checkout.bizumPhoneInvalid" };
  }

  return { valid: true, normalized, errorKey: "" };
}
